import React from "react";
import { createRoot, type Root } from "react-dom/client";
import { getTarget } from "@/canv/utils";
import { ShortcutsWindowLayout } from "./ShortcutsWindowLayout";
import styles from "./shortcutsWindow.module.css";

export class ShortcutsWindow {
    async show() {
        this.wrapper = document.createElement("div");
        this.wrapper.classList.add(styles.shortcutsWindowWrapper);

        const shortcutsWindowLayout = React.createElement(ShortcutsWindowLayout);

        this.root = createRoot(this.wrapper);
        this.root.render(shortcutsWindowLayout);

        document.body.appendChild(this.wrapper);

        this.init();
    }

    init() {
        this.wrapper?.addEventListener("mousedown", this.wrapperClick.bind(this), false);
    }

    hide() {
        this.root?.unmount();
        this.wrapper?.parentNode?.removeChild(this.wrapper);
    }

    wrapperClick(e) {
        const tryInner = getTarget(e, styles.shortcutsWindow);

        if (tryInner == null) {
            this.hide();
        }
    }

    root: Root | null = null;
    wrapper: HTMLElement | null = null;
}
